import React from 'react';

/**
 * Düz metin içindeki adresleri tıklanabilir bağlantıya çevirir.
 *
 * Neden `dangerouslySetInnerHTML` DEĞİL: bu metinler kullanıcı girdisi
 * (iş açıklaması, iş notu). HTML'e çevirip basmak stored XSS demek olurdu —
 * repo genelinde ham HTML yalnızca sanitize edilerek basılıyor
 * (bkz. `utils/sanitizeHtml.js`). Burada hiç HTML üretmiyoruz: metni parçalayıp
 * React elemanları döndürüyoruz, yani metnin kendisi hiçbir zaman markup
 * olarak yorumlanmıyor.
 *
 * Kapsam: `http(s)://...`, `www....` ve e-posta adresleri. Şema listesi
 * bilinçli olarak dar — `javascript:` gibi bir şey hiçbir zaman `href`'e
 * giremesin diye.
 */

const PATTERN = /((?:https?:\/\/|www\.)[^\s<>"']+|[\w.+-]+@[\w-]+\.[\w.-]*\w)/gi;

// Cümle sonundaki noktalama adresin parçası değil: "detay: example.com."
// Kırpılan karakterler düz metin olarak geri basılıyor, kaybolmuyorlar.
const TRAILING = /[.,;:!?)\]}'"]+$/;

const hrefFor = (value) => {
  if (value.includes('@') && !value.includes('/')) return `mailto:${value}`;
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};

export const linkifyText = (text) => {
  if (!text) return text;

  const parts = [];
  let lastIndex = 0;
  let match;

  PATTERN.lastIndex = 0;
  while ((match = PATTERN.exec(text)) !== null) {
    const raw = match[0];
    const trailing = (raw.match(TRAILING) || [''])[0];
    const url = trailing ? raw.slice(0, -trailing.length) : raw;

    // Kırpma sonrası geriye adres kalmadıysa (ör. tek başına "...") link yapma.
    if (!url) continue;

    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    parts.push(
      <a
        key={`${match.index}-${url}`}
        href={hrefFor(url)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        {url}
      </a>
    );

    if (trailing) parts.push(trailing);
    lastIndex = match.index + raw.length;
  }

  if (parts.length === 0) return text;
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));

  return parts;
};

export default linkifyText;
